import { setPortalToken } from '../shared/api.js';

/**
 * Jeton du portail : lu dans le fragment de l'URL (`/p#<jeton>`), jamais dans le chemin ni la
 * requête, puis transmis à l'API dans l'en-tête `x-portal-token` (client typé et images).
 * Le fragment reste dans la barre d'adresse : le client peut recharger la page ou la garder
 * en favori ; il n'est ni envoyé au serveur ni transmis dans le Referer.
 */
let current: string | null = null;

export function initPortalToken(hash: string = typeof window === 'undefined' ? '' : window.location.hash): string | null {
  let raw = hash.replace(/^#/, '');
  try {
    raw = decodeURIComponent(raw);
  } catch {
    // fragment mal encodé : utilisé tel quel
  }
  const token = raw.trim();
  current = token.length > 0 ? token : null;
  setPortalToken(current);
  return current;
}

export function getPortalToken(): string | null {
  return current;
}
